export type CursorDirection = 'before' | 'after';
export type CursorPagingOptions<T = string | number> = {
  id: T;
  direction: CursorDirection;
  isInclusive: boolean;
};
